import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import CircularSpinner from '../../utils/CircularSpinner';
import { updateProfile } from "../../../redux/actions/authActions";
import './MyProfile.css';
import Navbar from '../../containers/Navbar/Navbar';

const MyProfile = () => {
    const user = useSelector((state) => state.user?.user);
    const [success, setSuccess] = useState("");
    const [failure, setFailure] = useState("");
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const [input, setInput] = useState({
        firstName: user?.first_name,
        lastName: user?.last_name,
        email: user?.email,
        gender: user?.gender,
    })

    const setInputHandler = (e) => {
        setInput({
            ...input,
            [e.target.id]: e.target.value
        })
    }

    const formSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const response = await dispatch(updateProfile(input));
        if(response.status === 200){
            setSuccess("Profile updated successfully");
        }else{
            const errorMessage = response.data.errorMessage || "Something went wrong !!";
            setFailure(errorMessage);
        }
        setLoading(false);
    }

    return (
        <div className='w-100 container'>
            <Navbar />
            <div className='w-75 mx-auto'>
                <div className="card p-4 h-50 shadow-lg profile-form">
                    <h3 className="text-center my-3">
                            My Profile
                    </h3>
                    {
                    success ? 
                        (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                {success}
                                <button type="button"  onClick = {() => setSuccess("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        ) : 
                        <></>
                    }
                    {
                        failure ? 
                        (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            {failure}
                            <button type="button" onClick = {() => setFailure("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close">

                            </button>
                        </div>
                        ) : 
                        <></>
                    }
                    <form className="form" onSubmit={formSubmit}>
                        <div className="form-group my-4 d-flex justify-content-between align-items-center">
                            <div className="d-flex flex-column w-50 me-3">
                                <p className="px-2"><strong>First Name :</strong></p>
                                <input className="form-control w-100" 
                                type="text" 
                                name="" 
                                id="firstName"
                                value={input.firstName}
                                onChange={setInputHandler}
                                placeholder="First Name"/>
                            </div>
                            <div className="d-flex flex-column w-50 me-3">
                                <p className="px-2"><strong>Last Name: </strong></p>
                                <input 
                                className="form-control w-100" 
                                type="text" 
                                name="" id="lastName"
                                value={input.lastName} 
                                onChange={setInputHandler}
                                placeholder="Last Name"/>
                            </div>
                        </div>
                        <div className="form-group my-4">
                            <p className="px-2"><strong>Email: </strong></p>
                            <input type="text" 
                                   className="form-control" 
                                   name="" 
                                   id="email"
                                   value={input.email}
                                   onChange={setInputHandler}
                                   disabled={true}
                                   placeholder="Email Address"/>
                        </div>
                        <div className="form-group my-4">
                            <p className="px-2"><strong>Gender: </strong></p>
                            <div className="d-flex">
                                <div className="mr-5">
                                    <span className="px-2"><strong>Male: </strong></span>
                                    <input  type="radio" 
                                            id="gender" 
                                            value="male" 
                                            checked={input.gender==="male"} 
                                            onChange={setInputHandler}
                                    />
                                </div>
                                <div className="me-5">
                                    <span className="px-2"><strong>Female: </strong></span>
                                    <input  type="radio" 
                                            id="gender" 
                                            value="female" 
                                            checked={input.gender==="female"}
                                            onChange={setInputHandler}
                                />
                                </div>
                            </div>
                        </div>
                        <div className="form-group my-4">
                           <button className="w-100 btn btn-primary" disabled={loading}>
                               {
                                   loading 
                                   ? <div className="text-center"> 
                                        <CircularSpinner />
                                     </div> : "Submit"
                               }
                           </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default MyProfile
